class Resources {
  constructor(resources) {
    const resourceMap = new Map(Object.entries(resources));
    if (!resourceMap.get("default")) {
      throw new Error("Missing default Translation");
    }
    this.resources = resourceMap;
  }
  get(locale) {
    const resource = this.resources.get(locale);
    if (resource) {
      return resource;
    }
    const [lng] = locale.split("-");
    const lngResource = this.resources.get(lng);
    if (lng && lngResource) {
      return lngResource;
    }
    console.warn(`${locale} translations are missing.`);
    return this.resources.get("default");
  }
}
var Resources_default = Resources;
export {
  Resources_default as default
};
